import { useState, useRef } from 'react';
import { HEADER_LIST } from './HubTableData';
import { changePriceNoUnit, changeSaleStatusData } from '../../common/utils';
import { useEffect } from 'react';
import Pagination from 'react-js-pagination';
import axios from 'axios';
import moment from 'moment';
import HubDetailSlideModal from './HubDetailSlideModal';
import loadingImg from '../../../img/loading.png';
import { motion, AnimatePresence } from 'framer-motion';
import HubBookmarkModal from './HubBookmarkModal';
const xlsx = require('xlsx');
function HubTable(props) {
	const dataTable = useRef(null);
	const [TableHeight, setTableHeight] = useState(0);
	const [HeaderList, setHeaderList] = useState([]);
	const [TableData, setTableData] = useState([]);
	const [Page, setPage] = useState(1); // 현재 페이지 번호
	const [PostPerPage, setPostPerPage] = useState(10); // 페이지 당 게시글 개수
	const [IsPostPerPageOpen, setIsPostPerPageOpen] = useState(false);
	const indexOfLastPost = Page * PostPerPage;
	const indexOfFirstPost = indexOfLastPost - PostPerPage;
	const PageLengthList = [10, 50, 100, 500];
	const [IsAllCheck, setIsAllCheck] = useState(false);
	const [CheckedCommodity, setCheckedCommodity] = useState([]);
	const [HubDetailData, setHubDetailData] = useState({});
	const [SaleStaus, setSaleStaus] = useState('');
	const [IsSaleStatusOpen, setIsSaleStatusOpen] = useState(false);
	const SaleStatusList = ['SALE', 'SOLDOUT', 'EXTINCTION', 'EXCEPTION'];
	const [IsLoading, setIsLoading] = useState(false);
	const [IsNoBG, setIsNoBG] = useState(false);
	const [IsBookmarkModalOpen, setIsBookmarkModalOpen] = useState(false);
	const handleBookmarkOpen = (e) => {
		e.preventDefault();
		setIsBookmarkModalOpen(true);
	};
	// 수정필요
	const exportToExcel = () => {
		if (TableData) {
			const originalTableData = TableData;
			// 데이터 키값 변경
			const modifiedTableData = originalTableData.map((item) => {
				return {
					공급사코드: item.vendorCode,
					공급상품코드: item.commodityCode,
					상품관리코드: `${item.vendorCode}_${item.commodityCode}`,
					상품명: item.modInformation?.name ? item.modInformation.name : item.information.name,
					도매가격: item.information.wholesalePrice,
					소매가격: item.modInformation?.retailPrice ? item.modInformation.retailPrice : item.information.retailPrice,
					소비자준수가: item.modInformation?.recommendedRetailPrice ? item.modInformation.recommendedRetailPrice : item.information.recommendedRetailPrice || '-',
					배송정보: item.information.deliveryType,
					배송비: item.information.deliveryFee,
					과세: item.information.taxation === 1 ? '과세' : '비과세',
					최소구매수량: item.information.minPurchaseQuantity,
					카테고리: `${item.category?.categoryName || ''}`,
					키워드: item.keywords?.join(',') || '',
					정보고시: item.information.attributes
						.filter((f) => f && !!f.attrType.length && !~f.attrType.indexOf('최저가'))
						.map((m) => `${m.attrType}-${m.attrValue}`)
						.join('\n'),
					옵션: item.information.options
						.map((m) => [m.title, m.optionId, m.optionName1, m.optionName2, m.optionName3, m.optionStatus, m.optionStock, m.surcharge].filter((f) => f).join('^'))
						.join('\n'),
					상태: item.status,
					목록이미지: item.information.images.map((m) => m.imageUrl).join('\n'),
					상세페이지: item.information.detailContent.length > 32767 ? 'too long length' : item.information.detailContent,
					네이버최저가: item.information.attributes
						.filter((f) => f && ~f.attrType.indexOf('최저가'))
						.map((m) => m.attrValue)
						.join(''),
					카테고리코드: item.category?.smartstore || '',
					// 등록일자: item.regDate
				};
			});

			const ws = xlsx.utils.json_to_sheet(modifiedTableData, {
				skipHeader: false, // 첫 번째 행을 열의 제목으로 사용함
			});

			ws['!cols'] = [
				{ wch: 20 }, // A열
				{ wch: 20 }, // B열
				{ wch: 20 }, // C열
				{ wch: 20 }, // D열
				{ wch: 20 }, // E열
				{ wch: 20 }, // F열
				{ wch: 20 }, // G열
				{ wch: 20 }, // H열
				{ wch: 20 }, // I열
				{ wch: 20 }, // J열
				{ wch: 20 }, // K열
				{ wch: 20 }, // L열
				{ wch: 20 }, // M열
				{ wch: 20 }, // N열
				{ wch: 20 }, // O열
				{ wch: 20 }, // P열
				{ wch: 20 }, // Q열
				{ wch: 20 }, // R열
				{ wch: 20 }, // S열
				{ wch: 20 }, // T열
			];
			// 워크북 생성 및 시트 추가
			const wb = xlsx.utils.book_new();
			xlsx.utils.book_append_sheet(wb, ws, 'Sheet1');
			xlsx.writeFile(wb, `aios_product_list_v1_${moment().format('YYYYMMDDHH')}.xlsx`); //두번쨰 인수는 파일 이름.
		}
	};
	const setParams = (params) => {
		setIsLoading(true);
		props.getIsLoading(true);
		setCheckedCommodity([]);
		axios({
			method: 'POST',
			url: `${window.location.protocol}//${window.location.hostname}:3001/getProducts`,
			data: {
				token: localStorage.getItem('token'),
				config: params,
			},
			xhrFields: {
				withCredentials: true,
			},
		})
			.then((res) => {
				const DataArray = res.data.productInfo?.map((obj) => {
					return {
						...obj,
						isHubDetailSlideModalOpen: false,
					};
				});
				setTableData(DataArray || []);
				setTimeout(() => {
					setIsLoading(false);
					props.getIsLoading(false);
				}, 2000);
			})
			.catch(function (error) {
				console.log(error);
			});
	};

	const handleBlurSaleStatusContainer = (e) => {
		e.preventDefault();
		setTimeout(() => {
			setIsSaleStatusOpen(false);
		}, 200);
	};
	const handleSaleStatusOpen = () => {
		setIsSaleStatusOpen(!IsSaleStatusOpen);
	};
	const handleSaleStatus = (e, value) => {
		if (CheckedCommodity && CheckedCommodity.length > 0) {
			const newSaleStatus = value;
			if (SaleStaus !== newSaleStatus) {
				setSaleStaus(newSaleStatus);
			}
			const productNos = CheckedCommodity.map(m => m.productNo);
			/* eslint-disable no-restricted-globals */
			const isOk = confirm(`${productNos}의 판매상태를 ${changeSaleStatusData(newSaleStatus)}로 수정하시겠습니까?`);
			/* eslint-enable no-restricted-globals */
			if (isOk) {
				//판매상태 요청API
				axios({
					method: 'POST',
					url: `${window.location.protocol}//${window.location.hostname}:3001/updateProduct`,
					data: {
						token: localStorage.getItem('token'),
						config: {
							productNos,
							type: 'status',
							value: newSaleStatus,
						},
					},
					xhrFields: {
						withCredentials: true,
					},
				})
					.then((res) => {
						// 테이블 표시되는 상태 실시간 변동
						setParams(props.params);
					})
					.catch((error) => { });
			}
			setSaleStaus('');
		} else {
			alert('상품을 선택해주세요.');
		}
	};
	const handleBlurPageSizeContainer = () => {
		setTimeout(() => {
			setIsPostPerPageOpen(!IsPostPerPageOpen);
		}, 200);
	};
	const handlePostPerPageOpen = () => {
		setIsPostPerPageOpen(!IsPostPerPageOpen);
	};
	const handlePostPerPage = (e, value) => {
		const newPerPageSize = value;
		if (PostPerPage !== newPerPageSize) {
			setPage(1);
			setPostPerPage(newPerPageSize);
			return;
		}
	};
	const handlePageChange = (page) => {
		if (Page !== page) {
			return setPage(page);
		}
	};
	useEffect(() => {
		const nowTableIdxArray = TableData?.slice(indexOfFirstPost, indexOfLastPost).map((el) => el.productNo);
		const nowPageChecked = nowTableIdxArray.filter((item) => CheckedCommodity.map(m => m.productNo).includes(item));
		if (nowTableIdxArray.length === nowPageChecked.length && TableData.length) {
			setIsAllCheck(true);
		} else {
			setIsAllCheck(false);
		}
	}, [Page, CheckedCommodity]);
	const handleCheckAllCommodity = (e) => {
		const checkedArray = TableData?.slice(indexOfFirstPost, indexOfLastPost);
		console.log(TableData);
		if (e.target.checked) {
			setIsAllCheck(true);
			let newArray = [];
			newArray = CheckedCommodity.concat(checkedArray);
			newArray = newArray.filter((value, index, self) => self.indexOf(value) === index);
			setCheckedCommodity(newArray);
		} else {
			let newArray = CheckedCommodity.filter((item) => !checkedArray.map(m => m.productNo).includes(item.productNo));
			setIsAllCheck(false);
			setCheckedCommodity(newArray);
		}
	};
	const handlecheckedCommodity = (e, item) => {
		const newValue = e.target.value;
		let newCheckedCommodity = [];
		if (e.target.checked) {
			newCheckedCommodity = [...CheckedCommodity, item];
		} else {
			newCheckedCommodity = CheckedCommodity.filter(f => f.information.name !== e.target.value);
		}
		setCheckedCommodity(newCheckedCommodity);
	};
	const handleSlideModalOpen = (e, item) => {
		e.preventDefault();
		setIsLoading(true);
		props.getIsLoading(true);

		setHubDetailData(item || {});
		handleSlideModalContainer(item.productNo);
		setIsNoBG(true);
		setTimeout(() => {
			setIsLoading(false);
			props.getIsLoading(false);
		}, 1000);
		setTimeout(() => {
			setIsNoBG(false);
		}, 1500);
	};
	const handleSlideModalContainer = (productNo) => {
		const updatedData = [...TableData];
		for (let i = 0; i < TableData.length; i++) {
			if (TableData[i].productNo === productNo) {
				updatedData[i].isHubDetailSlideModalOpen = !updatedData[i].isHubDetailSlideModalOpen;
			} else {
				updatedData[i].isHubDetailSlideModalOpen = false;
			}
		}
		setTimeout(() => {
			setTableData(updatedData);
		}, 200);
	};
	const handleVendorSite = (url) => {
		if (url != null) window.open(url, '_blank', 'noopener, noreferrer');
	};
	useEffect(() => {
		if (Object.keys(props.params).length > 0) {
			const params = props.params;
			setParams(params);
			setPage(1);
		}
	}, [props.params]);
	useEffect(() => {
		if (Object.keys(props.countParams).length > 0) {
			const params = props.countParams;
			setParams(params);
			setPage(1);
		}
	}, [props.countParams]);
	useEffect(() => {
		setHeaderList(HEADER_LIST);
	}, []);
	useEffect(() => {
		if (dataTable.current) {
			const height = dataTable.current.clientHeight;
			setTableHeight(height);
		}
	}, [TableData, PostPerPage]);
	return (
		<div className='hub-table'>
			<div className='table-top'>
				<div className='table-top-left'>
					<p>
						상품목록 (총 <span className='pointText'>{TableData.length}</span>
						개)
					</p>
					<div className='container' onBlur={(e) => handleBlurSaleStatusContainer(e)} style={{ marginLeft: '10px' }}>
						<label onClick={() => handleSaleStatusOpen()}>
							<button className='dropdown-button'>
								<span>{SaleStaus ? changeSaleStatusData(SaleStaus) : '판매상태변경'}</span>
								<span className='dropdown-button-arrow'>{IsSaleStatusOpen ? '▲' : '▼'}</span>
							</button>
						</label>
						{IsSaleStatusOpen && (
							<div className={IsSaleStatusOpen ? 'dropdown-container open' : 'dropdown-container'}>
								<ul className='dropdown-content'>
									{SaleStatusList.map((el, idx) => (
										<li key={idx} onClick={(e) => handleSaleStatus(e, el)}>
											{changeSaleStatusData(el)}
										</li>
									))}
								</ul>
							</div>
						)}
					</div>
				</div>
				<div className='table-top-right'>
					<button onClick={(e) => handleBookmarkOpen(e)}>장바구니</button>
					{IsBookmarkModalOpen && <HubBookmarkModal data-name={CheckedCommodity.map(m => m.information.name)} data-productNo={CheckedCommodity.map(m => m.productNo)} getBookmarkModalOpen={(isOpen) => setIsBookmarkModalOpen(isOpen)} />}
					<div className='container' onBlur={(e) => handleBlurPageSizeContainer(e)} style={{ marginLeft: '10px' }}>
						<label onClick={() => handlePostPerPageOpen()}>
							<button className='dropdown-button' disabled={IsLoading ? true : false}>
								<span>{PostPerPage}개씩</span>
								<span className='dropdown-button-arrow'>{IsPostPerPageOpen ? '▲' : '▼'}</span>
							</button>
						</label>
						{IsPostPerPageOpen && (
							<div className={IsPostPerPageOpen ? 'dropdown-container open' : 'dropdown-container'}>
								<ul className='dropdown-content'>
									{PageLengthList.map((el, idx) => (
										<li key={idx} onClick={(e) => handlePostPerPage(e, el)}>
											{el}개씩
										</li>
									))}
								</ul>
							</div>
						)}
					</div>
					<button onClick={exportToExcel} style={{ marginLeft: '10px' }}>
						엑셀다운로드
					</button>
				</div>
			</div>
			<div className='data-table' style={{ height: TableHeight }}>
				<div className='fixed-table'>
					<table ref={dataTable}>
						<thead>
							<tr>
								{HeaderList.slice(0, 4).map((el, index) => {
									if (el === '선택') {
										return (
											<th key={index}>
												<input type='checkbox' checked={IsAllCheck} onChange={(e) => handleCheckAllCommodity(e)} />
											</th>
										);
									} else {
										return <th key={index}>{el}</th>;
									}
								})}
							</tr>
						</thead>
						<tbody>
							{TableData.length === 0 && (
								<tr className='defaultTable'>
									<td colSpan={HEADER_LIST.length} style={{ borderRight: 'none' }}>
										<div></div>
									</td>
								</tr>
							)}
							{IsLoading && (
								<AnimatePresence>
									<motion.tr
										initial={{ opacity: 0 }}
										animate={{ opacity: 1, transition: { duration: 0.2 } }}
										exit={{
											opacity: 0,
											transition: { delay: 0.1, duration: 0.3 },
										}}
										className={IsNoBG ? 'loading noBg' : 'loading'}
									>
										<td colSpan={HEADER_LIST.length} style={{ opacity: 0 }}>
											{/* <a
												href='https://www.flaticon.com/kr/free-icons/'
												title='로딩 아이콘'
												style={{ display: 'none' }}
											>
												로딩 아이콘 제작자: Krystsina Mikhailouskaya - Flaticon
											</a> */}
											<img src={loadingImg} alt='로딩아이콘' className='loadingImg' />
										</td>
									</motion.tr>
								</AnimatePresence>
							)}
							{TableData?.slice(indexOfFirstPost, indexOfLastPost).map((item, index) => (
								<tr key={index}>
									{/* 선택 */}
									<td>
										<input
											type='checkbox'
											value={item.information.name}
											checked={CheckedCommodity?.map(m => m.productNo).includes(item.productNo)}
											onChange={(e) => {
												handlecheckedCommodity(e, item);
											}}
										/>
									</td>
									{/* 수정 */}
									<td>
										<button onClick={(e) => handleSlideModalOpen(e, item)}>수정</button>
										<AnimatePresence>
											{item.isHubDetailSlideModalOpen && <HubDetailSlideModal data={HubDetailData} getHubDetailSlideModalOpen={() => handleSlideModalContainer(item.productNo)} />}
										</AnimatePresence>
									</td>
									{/**도매사*/}
									<td>{item.vendorCode}</td>
									<td>
										{/**상품관리코드 */}
										<span className='clickTd' onClick={() => handleVendorSite(item.originUrl)}>
											{item.commodityCode}
										</span>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
				<div className='scroll-table' style={IsLoading ? { left: '-1px' } : {}}>
					<table>
						<thead>
							<tr>
								{HeaderList.slice(4).map((el, index) => {
									if (el === '선택') {
										return (
											<th key={index}>
												<input type='checkbox' checked={IsAllCheck} onChange={(e) => handleCheckAllCommodity(e)} />
											</th>
										);
									} else {
										return <th key={index}>{el}</th>;
									}
								})}
							</tr>
						</thead>
						<tbody>
							{IsLoading && (
								<AnimatePresence>
									<motion.tr
										initial={{ opacity: 0 }}
										animate={{ opacity: 1, transition: { duration: 0.2 } }}
										exit={{
											opacity: 0,
											transition: { delay: 0.1, duration: 0.3 },
										}}
										className={IsNoBG ? 'loading noBg' : 'loading'}
										style={{ background: 'none' }}
									>
										<td colSpan={HEADER_LIST.length} style={{ opacity: 0 }}>
											{/* <a
												href='https://www.flaticon.com/kr/free-icons/'
												title='로딩 아이콘'
												style={{ display: 'none' }}
											>
												로딩 아이콘 제작자: Krystsina Mikhailouskaya - Flaticon
											</a> */}
											<img src={loadingImg} alt='로딩아이콘' className='loadingImg' />
										</td>
									</motion.tr>
								</AnimatePresence>
							)}
							{TableData.length === 0 && (
								<tr className='defaultTable'>
									<td colSpan={HEADER_LIST.length} style={{ borderLeft: 'none' }}>
										<div>데이터가 없습니다.</div>
									</td>
								</tr>
							)}
							{IsLoading && (
								<AnimatePresence>
									<motion.tr
										initial={{ opacity: 0 }}
										animate={{ opacity: 1, transition: { duration: 0.2 } }}
										exit={{
											opacity: 0,
											transition: { delay: 0.1, duration: 0.3 },
										}}
										className={IsNoBG ? 'loading hub noBg' : 'loading hub'}
									>
										<td colSpan={HEADER_LIST.length}>
											{/* <a
												href='https://www.flaticon.com/kr/free-icons/'
												title='로딩 아이콘'
												style={{ display: 'none' }}
											>
												로딩 아이콘 제작자: Krystsina Mikhailouskaya - Flaticon
											</a> */}
											<img src={loadingImg} alt='로딩아이콘' className='loadingImg' />
										</td>
									</motion.tr>
								</AnimatePresence>
							)}
							{TableData?.slice(indexOfFirstPost, indexOfLastPost).map((item) => (
								<tr key={item.productNo}>
									{/**상품명*/}
									<td>{item.information.name}</td>
									{/**판매상태*/}
									<td>{changeSaleStatusData(item.status)}</td>
									{/**재고*/}
									<td>{item.information.stock}</td>
									{/**도매가격*/}
									<td>{changePriceNoUnit(item.information.wholesalePrice)}</td>
									{/**소매가걱*/}
									<td>{changePriceNoUnit(item.information.retailPrice)}</td>
									{/**배송비*/}
									<td>{changePriceNoUnit(item.information.deliveryFee)}</td>
									{/**옵션*/}
									<td>{item.information?.options && item.information?.options.length > 0 ? 'Y' : 'N'}</td>
									{/**상품등록일*/}
									<td>{item.regDate}</td>
									{/**최종수정일*/}
									<td>{item.updDate}</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</div>
			<Pagination
				activePage={Page}
				itemsCountPerPage={Number(PostPerPage)}
				totalItemsCount={TableData.length}
				pageRangeDisplayed={10}
				prevPageText={'‹'}
				nextPageText={'›'}
				onChange={handlePageChange}
			/>
		</div>
	);
}

export default HubTable;
